'use strict';

function getVideoUrl(videoId) {
  var baseUrl = 'https://dailymotion.com/video/';
  return baseUrl + videoId;
}

function getVideoIdFromUrl(url) {

  var urlRegex = /dailymotion\.com\/(?:video|playlist)\/([^_/]+)/gi;
  var match = urlRegex.exec(url);
  if (match && match.length && match[1]) {
    //if there is a match, the second group is the id we want
    return match[1];
  }
}

module.exports = {
  getVideoUrl: getVideoUrl,
  getVideoIdFromUrl: getVideoIdFromUrl
};


// WEBPACK FOOTER //
// ./~/santa-platform-utils/lib/videoUrlsUtils/dailymotionVideoUtils.js